import { relationshipGuids, partnerGuids } from '../../guids';
import {
  sharedRelationshipFormProps,
  relationshipV3FormFields
} from '../../../pages/components/forms/formHelpers';

export const mockRelationshipsV2PutPost = {
  [relationshipGuids.default]: {
    relationshipId: {
      ...sharedRelationshipFormProps.relationshipId,
      value: relationshipGuids.default,
      required: false,
      valid: true
    },
    relationshipCode: {
      ...relationshipV3FormFields.relationshipCode,
      value: '123456',
      required: true,
      valid: true
    },
    relationshipName: {
      ...relationshipV3FormFields.relationshipName,
      value: 'Partner with Transaction Report Data',
      required: true,
      valid: true
    },
    parentRelationshipId: {
      ...relationshipV3FormFields.parentRelationshipId,
      value: relationshipGuids.relationship05,
      required: true,
      valid: true
    },
    childPartnerId: {
      ...relationshipV3FormFields.childPartnerId,
      value: partnerGuids.partner02,
      required: true,
      valid: true
    },
    bankName: {
      ...relationshipV3FormFields.bankName,
      value: 'CYNERGY',
      required: true,
      valid: true
    },
    processorName: {
      ...relationshipV3FormFields.processorName,
      value: 'FIRST_DATA',
      required: true,
      valid: true
    },
    processorFrontEnd: {
      ...relationshipV3FormFields.processorFrontEnd,
      value: 'test',
      required: false,
      valid: true
    },
    paymentGateway: {
      ...relationshipV3FormFields.paymentGateway,
      value: 'NMI',
      selected: 'NMI',
      required: true,
      valid: true
    },
    gatewayAffiliateId: {
      ...sharedRelationshipFormProps.gatewayAffiliateId,
      value: 'f1_house',
      required: false,
      valid: true
    },
    riskProfile: {
      ...relationshipV3FormFields.riskProfile,
      value: 'preferred',
      selected: 'preferred',
      required: true,
      valid: true
    },
    agentChain: {
      ...relationshipV3FormFields.agentChain,
      value: '012345',
      required: false,
      valid: true
    },
    inactive: {
      ...relationshipV3FormFields.inactive,
      value: false,
      selected: 'no',
      required: true,
      valid: true
    }
  },
  [relationshipGuids.relationship02]: {
    relationshipId: {
      ...sharedRelationshipFormProps.relationshipId,
      value: relationshipGuids.relationship02,
      required: false,
      valid: true
    },
    relationshipCode: {
      ...relationshipV3FormFields.relationshipCode,
      value: '189101',
      required: true,
      valid: true
    },
    relationshipName: {
      ...relationshipV3FormFields.relationshipName,
      value: '0CsKQFgXSYEb4XH',
      required: true,
      valid: true
    },
    parentRelationshipId: {
      ...relationshipV3FormFields.parentRelationshipId,
      value: relationshipGuids.relationship05,
      required: true,
      valid: true
    },
    childPartnerId: {
      ...relationshipV3FormFields.childPartnerId,
      value: partnerGuids.partner03,
      required: true,
      valid: true
    },
    bankName: {
      ...relationshipV3FormFields.bankName,
      value: 'CYNERGY',
      required: true,
      valid: true
    },
    processorName: {
      ...relationshipV3FormFields.processorName,
      value: 'FIRST_DATA',
      required: true,
      valid: true
    },
    processorFrontEnd: {
      ...relationshipV3FormFields.processorFrontEnd,
      value: 'test',
      required: false,
      valid: true
    },
    paymentGateway: {
      ...relationshipV3FormFields.paymentGateway,
      value: 'Test Gateway',
      required: true,
      valid: true
    },
    gatewayAffiliateId: {
      ...sharedRelationshipFormProps.gatewayAffiliateId,
      value: null,
      required: false,
      valid: true
    },
    riskProfile: {
      ...relationshipV3FormFields.riskProfile,
      value: 'standard',
      selected: 'standard',
      required: true,
      valid: true
    },
    agentChain: {
      ...relationshipV3FormFields.agentChain,
      value: '012345',
      required: false,
      valid: true
    },
    inactive: {
      ...relationshipV3FormFields.inactive,
      value: false,
      selected: 'no',
      required: true,
      valid: true
    }
  },
  [relationshipGuids.relationship03]: {
    relationshipId: {
      ...sharedRelationshipFormProps.relationshipId,
      value: relationshipGuids.relationship04,
      required: false,
      valid: true
    },
    relationshipCode: {
      ...relationshipV3FormFields.relationshipCode,
      value: '112131',
      required: true,
      valid: true
    },
    relationshipName: {
      ...relationshipV3FormFields.relationshipName,
      value: 'CrmCreateRelationshipFT',
      required: true,
      valid: true
    },
    parentRelationshipId: {
      ...relationshipV3FormFields.parentRelationshipId,
      value: relationshipGuids.relationship05,
      required: true,
      valid: true
    },
    childPartnerId: {
      ...relationshipV3FormFields.childPartnerId,
      value: partnerGuids.default,
      required: true,
      valid: true
    },
    bankName: {
      ...relationshipV3FormFields.bankName,
      value: 'CYNERGY',
      required: true,
      valid: true
    },
    processorName: {
      ...relationshipV3FormFields.processorName,
      value: 'FIRST_DATA',
      required: true,
      valid: true
    },
    processorFrontEnd: {
      ...relationshipV3FormFields.processorFrontEnd,
      value: 'test',
      required: false,
      valid: true
    },
    paymentGateway: {
      ...relationshipV3FormFields.paymentGateway,
      value: 'Test Gateway',
      required: true,
      valid: true
    },
    gatewayAffiliateId: {
      ...sharedRelationshipFormProps.gatewayAffiliateId,
      value: null,
      required: false,
      valid: true
    },
    riskProfile: {
      ...relationshipV3FormFields.riskProfile,
      value: 'elevated',
      selected: 'elevated',
      required: true,
      valid: true
    },
    agentChain: {
      ...relationshipV3FormFields.agentChain,
      value: '012345',
      required: false,
      valid: true
    },
    inactive: {
      ...relationshipV3FormFields.inactive,
      value: false,
      selected: 'no',
      required: true,
      valid: true
    }
  }
};

export const mockRelationshipV2Put = (body, params, options) => {
  const { guid } = options || {};
  return { [guid]: { relationshipId: 'mock-relationship-id' } };
};
